import { app } from '../../../../../../app';
import { Controller } from './export-accounts.controller';

app.component('companyUserDirectoriesDirectoryGroupsAllAccountsExport', {
    bindings: {
        accounts: '<',
        currentCompany: '<',
    },
    controller: Controller,
    templateUrl: require('./export-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/all-accounts/export/export-accounts.component.js